export default __webpack_public_path__ + "static/media/Boots of the Scattered Gods.737c7f6b.jpg";